module.exports = __webpack_public_path__ + "static/media/analysis-macrovector-02-b 6.1e8d5b98.png";